import {Injectable} from '@angular/core';
import {Meta} from '@angular/platform-browser';

@Injectable({
  providedIn: 'root'
})
export class SeoService {
  constructor(private meta: Meta) {
  }

  public addTags(description: string, image: string, title: string, type: string = 'website'): void {
    this.meta.updateTag({property: 'og:description', content: description});
    this.meta.updateTag({
      content: description,
      name: 'description'
    });
    this.meta.updateTag({property: 'og:image', content: image});
    this.meta.updateTag({property: 'og:locale', content: 'el_GR'});
    this.meta.updateTag({property: 'og:title', content: title});
    this.meta.updateTag({property: 'og:type', content: type});
  }
}
